import styled from "styled-components";
import { CenterFlexColumn } from "styles/layout";
import { Theme } from "theme";

export const TournamentDetailsContainer = styled(CenterFlexColumn)`
  width: 100px;
  row-gap: 2px;
  color: ${Theme.panelForegroundLight};

  span {
    max-width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: clip;
  }
`;
